export const taskStatuses = [
  'In Progress', // 0
  'Complete', // 1
  'On Hold', // 2
  'With Client', // 3
  // 'Info Required', // 4
  // 'Unknown', // 5
  'Cancelled' // 6
]
